<template>
  <div class="text-center">
    <v-card>
      <div class="container-fluid">
        <v-row justify="center" class="col-12">
          <v-col cols="12">
            <v-icon @click="cancelForm" class="float-right">mdi-close</v-icon>
            <h1 class="text-center">{{title}}</h1>
          </v-col>
            <v-form
            ref="form"
            v-model="formValid"
            method="post"
            >
              <v-row class="col-12">
                <v-col cols="6">
              <v-text-field
                color="warning"
                v-model="form.name"
                :rules="[rules.required]"
                label="Název jídelníčku"
                prepend-icon="mdi-form-textbox"
                outlined
                required
                :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
              >
              </v-text-field>

                </v-col>
                <v-col cols="6">
                  <v-select
                    color="warning"
                    prepend-icon="mdi-format-list-bulleted"
                    label="Vyberte typ jídelníčku"
                    v-model="form.dietType"
                    item-text="name"
                    return-object
                    :items="dietTypes"
                    :rules="[rules.required]"
                    :search-input.sync="search"
                    hide-selected
                    persistent-hint
                    outlined
                    :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    color="warning"
                    prepend-icon="mdi-format-list-bulleted"
                    label="Vyberte typ stravy"
                    v-model="form.foodTypes"
                    item-text="name"
                    return-object
                    :items="foodTypes"
                    :rules="[rules.required]"
                    :search-input.sync="search"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    deletable-chips
                    outlined
                    :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                  ></v-select>
                </v-col>
                <v-col cols="6">
              <v-menu
                ref="pickFrom"
                v-model="pickFrom"
                :close-on-content-click="false"
                :return-value.sync="form.dateFrom"
                transition="scale-transition"
                offset-y
                outlined
                max-width="290px"
                min-width="290px"
                :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    color="warning"
                    v-model="form.dateFrom"
                    label="Platnost od"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.dateFrom" no-title scrollable first-day-of-week="1">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="pickFrom = false">Zrušit</v-btn>
                  <v-btn text color="primary" @click="$refs.pickFrom.save(form.dateFrom)">OK</v-btn>
                </v-date-picker>
              </v-menu>
                </v-col>
                <v-col cols="6">
              <v-menu
                ref="pickTo"
                v-model="pickTo"
                :close-on-content-click="false"
                :return-value.sync="form.dateTo"
                transition="scale-transition"
                offset-y
                min-width="290px"
                outlined
                :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    color="warning"
                    v-model="form.dateTo"
                    label="Platnost do"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.dateTo" no-title scrollable first-day-of-week="1">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="pickTo = false">Zrušit</v-btn>
                  <v-btn text color="primary" @click="$refs.pickTo.save(form.dateTo)">OK</v-btn>
                </v-date-picker>
              </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="warning"
                    prepend-icon="mdi-cash-100"
                    v-model="form.deliveryPrice"
                    :rules="[rules.required, rules.number]"
                    label="Cena rozvozu"
                    required
                    outlined
                    :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="warning"
                    prepend-icon="mdi-cash-100"
                    v-model="form.packagePrice"
                    :rules="[rules.required, rules.number]"
                    label="Cena balení"
                    required
                    outlined
                    :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="warning"
                    prepend-icon="mdi-cash-100"
                    v-model="form.minPrice"
                    :rules="[rules.required, rules.number]"
                    label="Minimální cena objednávky"
                    required
                    outlined
                    :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="col-12">
                <v-col cols="6">
                 <div v-show="universalClosing">
                     <v-menu
                       ref="timePickUniversal"
                       v-model="timePickUniversal"
                       :close-on-content-click="false"
                       :nudge-right="40"
                       transition="scale-transition"
                       offset-y
                       max-width="290px"
                       min-width="290px"
                       outlined
                       :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                     >
                       <template v-slot:activator="{ on, attrs }">
                         <v-text-field
                           color="warning"
                           v-model="ordersClosing"
                           label="Uzavření objednávek"
                           prepend-icon="mdi-calendar-clock"
                           readonly
                           v-bind="attrs"
                           v-on="on"
                           required
                           outlined
                           :rules="universalClosing ? [rules.required] : []"
                           :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                         ></v-text-field>
                       </template>
                       <v-time-picker
                         v-model="ordersClosing"
                         full-width
                         required
                         outlined
                         format="24hr"
                       >
                         <v-spacer></v-spacer>
                         <v-btn text color="primary" @click="timePickUniversal = false">Zrušit</v-btn>
                         <v-btn text color="primary" @click="$refs.timePickUniversal.save(ordersClosing)">OK</v-btn>
                       </v-time-picker>
                     </v-menu>
                 </div>
                </v-col>
                    <v-col cols="6" v-show="universalClosing">
                      <v-switch
                        v-model="dayBeforeUniversal"
                        label="Den předem"
                      ></v-switch>
                    </v-col>
              </v-row>
                  <v-row class="col-12" v-show="!universalClosing">
                    <v-col cols="6">
                    <v-menu
                      ref="timePickBreakfast"
                      v-model="timePickArr[0]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                      :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="ordersClosingArr[0]"
                          label="Uzavření snídaně"
                          prepend-icon="mdi-calendar-clock"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          :rules="universalClosing ? [] : [rules.required]"
                          :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="ordersClosingArr[0]"
                        full-width
                        format="24hr"
                        @click:minute="$refs.timePickBreakfast.save(ordersClosingArr[0])"
                      ></v-time-picker>
                    </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        v-model="dayBeforeArr[0]"
                        label="Den předem"
                      ></v-switch>
                    </v-col>
                    <v-col cols="6">
                    <v-menu
                      ref="timePickMorningSnack"
                      v-model="timePickArr[1]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                      :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="ordersClosingArr[1]"
                          label="Uzavření dopolední svačiny"
                          prepend-icon="mdi-calendar-clock"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          :rules="universalClosing ? [] : [rules.required]"
                          :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="ordersClosingArr[1]"
                        full-width
                        format="24hr"
                        @click:minute="$refs.timePickMorningSnack.save(ordersClosingArr[1])"
                      ></v-time-picker>
                    </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        v-model="dayBeforeArr[1]"
                        label="Den předem"
                      ></v-switch>
                    </v-col>
                    <v-col cols="6">
                    <v-menu
                      ref="timePickLunch"
                      v-model="timePickArr[2]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                      :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="ordersClosingArr[2]"
                          label="Uzavření oběda"
                          prepend-icon="mdi-calendar-clock"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          :rules="universalClosing ? [] : [rules.required]"
                          :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="ordersClosingArr[2]"
                        full-width
                        format="24hr"
                        @click:minute="$refs.timePickLunch.save(ordersClosingArr[2])"
                      ></v-time-picker>
                    </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        v-model="dayBeforeArr[2]"
                        label="Den předem"
                      ></v-switch>
                    </v-col>
                    <v-col cols="6">
                    <v-menu
                      ref="timePickAfternoonSnack"
                      v-model="timePickArr[3]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                      :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="ordersClosingArr[3]"
                          label="Uzavření odpolední svačiny"
                          prepend-icon="mdi-calendar-clock"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          :rules="universalClosing ? [] : [rules.required]"
                          :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="ordersClosingArr[3]"
                        full-width
                        format="24hr"
                        @click:minute="$refs.timePickAfternoonSnack.save(ordersClosingArr[3])"
                      ></v-time-picker>
                    </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        v-model="dayBeforeArr[3]"
                        label="Den předem"
                      ></v-switch>
                    </v-col>
                    <v-col cols="6">
                    <v-menu
                      ref="timePickDinner"
                      v-model="timePickArr[4]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                      :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="ordersClosingArr[4]"
                          label="Uzavření večeře"
                          prepend-icon="mdi-calendar-clock"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          :rules="universalClosing ? [] : [rules.required]"
                          :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="ordersClosingArr[4]"
                        full-width
                        format="24hr"
                        @click:minute="$refs.timePickDinner.save(ordersClosingArr[5])"
                      ></v-time-picker>
                    </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        v-model="dayBeforeArr[4]"
                        label="Den předem"
                      ></v-switch>
                    </v-col>
                    <v-col cols="6">
                    <v-menu
                      ref="timePickSecondDinner"
                      v-model="timePickArr[5]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                      :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="ordersClosingArr[5]"
                          label="Uzavření druhé večeře"
                          prepend-icon="mdi-calendar-clock"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          :rules="universalClosing ? [] : [rules.required]"
                          :disabled="!(currentUser.roleId === 1 || currentUser.roleId === 2)"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="ordersClosingArr[5]"
                        full-width
                        format="24hr"
                        @click:minute="$refs.timePickSecondDinner.save(ordersClosingArr[5])"
                      ></v-time-picker>
                    </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        v-model="dayBeforeArr[5]"
                        label="Den předem"
                      ></v-switch>
                    </v-col>
                  </v-row>
              <v-row class="col-12">
                <v-col
                  cols="12"
                  v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                >
                  <v-checkbox
                    :label="'Univerzální uzavření'"
                    v-model="universalClosing"
                  required>
                  </v-checkbox>
                  <v-checkbox
                    label="Data jsou zkontrolována"
                    :rules="[rules.checked]"
                    v-model="dataChecked"
                    required>
                  </v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  class="text-right"
                  v-if="currentUser.roleId === 1|| currentUser.roleId === 2"
                >
                  <v-btn
                    :disabled="!formValid || wait"
                    color="warning"
                    class="mr-4"
                    @click="save"
                  >
                    Zapsat
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
        </v-row>
      </div>
    </v-card>
</div>
</template>

<script>
import rules from '../../../mixins/rules'
import { asFormString } from '../../../utils/formField'
import { mapGetters } from 'vuex'

export default {
  name: 'DietForm',
  mixins: [rules],
  props: ['item', 'foodTypes'],
  data () {
    return {
      wait: false,
      formValid: true,
      dialog: false,
      search: null,
      // times
      ordersClosing: this.item.ordersClosing,
      ordersClosingArr: this.item.ordersClosingArr ? this.item.ordersClosingArr.map(deadline => deadline.time) : [],
      // days before
      dayBeforeUniversal: this.item.dayBefore,
      dayBeforeArr: this.item.dayBeforeArr,
      // time pickers
      timePickUniversal: false,
      timePickArr: [false, false, false, false, false, false],
      universalClosing: this.item.universalClosing,
      pickTo: false,
      pickFrom: false,
      dietTypes: ['Instituční', 'Veřejný', 'Stálá nabídka'],
      form: {
        ...this.item,
        deliveryPrice: asFormString(this.item.deliveryPrice),
        packagePrice: asFormString(this.item.packagePrice)
      },
      dataChecked: false
    }
  },
  computed: {
    title () {
      if (this.currentUser.roleId === 1 || this.currentUser.roleId === 2) {
        return this.item.id ? 'Upravit jídelníček' : 'Přidat jídelníček'
      } else return 'Jídelníček'
    },
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  methods: {
    cancelForm () {
      this.$emit('formCanceled')
    },
    save () {
      Object.keys(this.form).forEach(key => {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      })
      this.wait = true

      const deadlines = []

      if (this.universalClosing) {
        for (let i = 0; i < 6; i++) {
          deadlines.push({
            time: this.ordersClosing,
            dayBefore: this.dayBeforeUniversal
          })
        }
      } else {
        for (let i = 0; i < 6; i++) {
          deadlines.push({
            time: this.ordersClosingArr[i],
            dayBefore: this.dayBeforeArr[i]
          })
        }
      }

      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/diets${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase({
          ...this.form,
          ordersClosingArr: deadlines
        })
      }
      this.$http(options)
        .then(() => {
          this.$emit('data-saved')
        })
        .catch(err => {
          this.wait = false
          console.log(err)
        })
    }
  },
  created () {
    // TODO: check item orders closing
  }
}
</script>

<style scoped>

</style>
